module.exports = __webpack_public_path__ + "VIPG2.png?f6e65fd8ca57cd562e7ae8c074e4b269";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG2.png
// module id = 74
// module chunks = 0